import React from "react";
import { offerConfig, priceTiers } from "../../data/megapack";
import { Countdown } from "../Countdown";
import { PriceCard } from "../PriceCard";
import { TrustRow } from "../TrustRow";
export function FinalCTA() {
  const trust = ["🔒 Pago 100% seguro", "⚡ Acceso digital", `🛡️ Garantía ${offerConfig.guaranteeDays} días`, `💳 ${offerConfig.paymentMethods.join(" | ")}`];
  return <section aria-label="Oferta final" className="bg-night" data-id="element-143" data-mp="3dsu2kc3b79tu">
      <div className="mx-auto max-w-2xl px-5 pb-12" data-id="element-144" data-mp="3hup51jwz7t97">
        <div className="rounded-2xl bg-blood px-4 py-8" data-id="element-145" data-mp="3hvgppzp1c6kp">
          <Countdown title="⏰ El precio cierra en:" compact data-id="element-146" data-mp="33v5yuwnq6rzj" />
        </div>
        <div className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-147" data-mp="33x8xg52y1tfv">
          <PriceCard tier={priceTiers.standard} data-id="element-148" data-mp="38usbp4zn667t" />
          <PriceCard tier={priceTiers.pro} data-id="element-149" data-mp="123jevf293xck" />
        </div>
        <div className="mt-7" data-id="element-150" data-mp="1242mo2y6t5cv">
          <TrustRow items={trust} data-id="element-151" data-mp="121q8m0vjvf53" />
        </div>
      </div>
    </section>;
}